// ------------------------------------------------------------------
// PURE MODULE: carousel.mod.js
// ------------------------------------------------------------------

export function carousel(element, index, radius, currentProgress, totalSlides) {
    
    // --- Safety Check ---
    if (!element || !totalSlides) return;

    // --- Shared constants ---
    const direction = 1;
    
    // Note: Original code did not use an offset, so we stick to strict index mapping.

    // --- Shared trigonometric math ---
    const theta_transform = index / totalSlides - currentProgress;
    
    const sinTheta = Math.sin(theta_transform * Math.PI * 2);
    const cosTheta = Math.cos(theta_transform * Math.PI * 2);
    const rotation = 360 * direction * theta_transform;

    // --- Apply transform ---
    // Direct CSS for maximum performance and to preserve rotation order logic
    element.style.transform = `translate3d(${direction * sinTheta * radius}px, 0px, ${cosTheta * radius}px) rotateY(${rotation}deg)`;
}